import axios from 'axios'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import axiosClient, { updateBook } from 'services/axios-client'
import { useBookQuery } from 'store/queries'
import { FinalPreviewContainer } from './style'

const FinalPreview = () => {
  const { bookId } = useParams()

  const [previewAddr, setPreviewAddr] = useState('')
  const [previewDate, setPreviewDate] = useState(null)

  const { data: book } = useBookQuery(bookId)

  useEffect(() => {
    if (bookId) {
      axiosClient
        .get(`PDF/book/${bookId}/preview?is_print=true`)
        .then((res) => {
          if (res.ok) {
            setPreviewAddr(res.data.fileUrl)
            setPreviewDate(moment(res.data.LastModified))
          }
        })
    }
  }, [bookId])

  const downloadPreview = () => {
    axios
      .get(previewAddr, {
        responseType: 'text',
      })
      .then((res) => {
        const downloadLink = document.createElement('a')
        const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
        downloadLink.href = URL.createObjectURL(pdfBlob)
        downloadLink.download = 'document.pdf'
        downloadLink.click()
        URL.revokeObjectURL(downloadLink.href)
      })
  }

  return (
    <FinalPreviewContainer className="section-container">
      <div className="modal-inner p20">
        <p>
          Print quality preview generated on {previewDate?.format('DD/MM/YY')}.
        </p>
        <Button className="btn-secondary" onClick={downloadPreview}>
          Download
        </Button>
      </div>

      <div className="modal-footer">
        <div className="btns-wrapper actions">
          <Button
            disabled={!previewAddr && !book?.preview_confirmed}
            className="btn-green"
            onClick={async () => {
              await updateBook(bookId, {
                preview_confirmed: true,
              })
            }}
          >
            Approve Preview
          </Button>
        </div>
      </div>
    </FinalPreviewContainer>
  )
}

export default FinalPreview
